import { render, staticRenderFns } from "./RestaurantContactDialog.vue?vue&type=template&id=17ffe92c"
import script from "./RestaurantContactDialog.vue?vue&type=script&lang=js"
export * from "./RestaurantContactDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports